import { api_ } from '@shared/plugIn/axios';

export type GiftEventType = 'courtesy_view' | 'store_view' | 'item_view';

interface GiftEventLogDto {
  event: GiftEventType;
  bugo: string;
  giftItem?: string;
  sessionId: string;
}

const getSessionId = (): string => {
  let id = sessionStorage.getItem('gift_sid');
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem('gift_sid', id);
  }
  return id;
};

export const trackGiftEvent = (
  event: GiftEventType,
  bugoId: string,
  giftItemId?: string,
) => {
  const dto: GiftEventLogDto = {
    event,
    bugo: bugoId,
    sessionId: getSessionId(),
  };
  if (giftItemId) dto.giftItem = giftItemId;

  api_.post('/public/gift-event-log', dto).catch((error) => {
    console.error('이벤트 로그 추적 실패:', error);
  });
};

/* ── Funnel Analysis ── */

export interface FunnelItemViewDetail {
  giftItemId: string;
  giftItemName: string;
  priceRetail: number;
  bugoCount: number;
  logCount: number;
}

export interface FunnelPurchaseDetail {
  giftItemId: string;
  giftItemName: string;
  priceRetail: number;
  bugoCount: number;
  orderCount: number;
  quantity: number;
  revenue: number;
}

export interface FunnelAnalysisResponse {
  period: { startDate: string | null; endDate: string | null };
  funnel: {
    totalBugos: number;
    totalFevents: number;
    courtesyView: number;
    storeView: number;
    itemView: number;
    purchased: number;
  };
  logCounts: {
    courtesyView: number;
    storeView: number;
    itemView: number;
  };
  purchaseSummary: {
    purchasedBugos: number;
    purchasedOrders: number;
    purchasedRevenue: number;
  };
  itemViewDetails: FunnelItemViewDetail[];
  purchaseDetails: FunnelPurchaseDetail[];
}

const buildFunnelParams = (startDate?: string, endDate?: string) => {
  const params: Record<string, string> = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  return new URLSearchParams(params).toString();
};

export const getGiftEventFunnel = async (
  startDate?: string,
  endDate?: string,
): Promise<FunnelAnalysisResponse> => {
  const qs = buildFunnelParams(startDate, endDate);
  const url = `/admin/gift-event-log/funnel${qs ? `?${qs}` : ''}`;
  const { data } = await api_.get<FunnelAnalysisResponse>(url);
  return data;
};

export const getGiftEventFunnelForAgencyAdmin = async (
  startDate?: string,
  endDate?: string,
): Promise<FunnelAnalysisResponse> => {
  const qs = buildFunnelParams(startDate, endDate);
  const url = `/bugo-agency-admin/gift-event-log/funnel${qs ? `?${qs}` : ''}`;
  const { data } = await api_.get<FunnelAnalysisResponse>(url);
  return data;
};
